import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            {/* Hero Section */}
            <section className="about-hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-text">
                            <h4 >Building <br /> Connections, <br /> Creating, Impact</h4>
                            <p>We're a consumer-led digital health company that helps people live healthier, happier lives.</p>
                            <button className="btn-primary">Learn More</button>
                        </div>
                        <div className="hero-images">
                            <div className="image-grid">
                                <div className="grid-item item1">
                                    <img src="/about_hero_2.png" alt="Impact" />
                                </div>
                                <div className="grid-item item2">
                                    <img src="/about_hero_1.png" alt="Connection" />
                                </div>
                                <div className="grid-item item3">
                                    <img src="/about_hero_3.png" alt="Opportunity" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission Section */}
            <section className="about-mission">
                <div className="container">
                    <div className="mission-content">
                        <div className="mission-text">
                            <h2>CabZigo helps people discover simpler ways to travel every day through personalized guidance and mindful habits.</h2>
                            <p>Driving is not just about moving from point A to B; it's about the experience, the comfort, and the peace of mind. Our digital platform is designed to make every journey count.</p>
                            <p>By providing real-time insights and 24/7 support, we're constantly improving our services to better serve your needs, whether it's daily commutes or weekend getaways.</p>
                        </div>
                        <div className="mission-image">
                            <div className="video-thumb">
                                <img src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1974&auto=format&fit=crop" alt="Team" />
                                <div className="play-btn">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How it Works */}
            <section className="how-it-works">
                <div className="container">
                    <h2 className="section-title">How does <span>CabZigo</span> work</h2>
                    <div className="steps-grid">
                        <div className="step-card">
                            <div className="step-num">1</div>
                            <h3>Innovation</h3>
                            <p>We leverage the latest technology to provide a seamless booking experience and efficient route optimization.</p>
                        </div>
                        <div className="step-card">
                            <div className="step-num">2</div>
                            <h3>Advanced AI tools</h3>
                            <p>Our intelligent systems predict demand and optimize fleet distribution to ensure availability when you need it.</p>
                        </div>
                        <div className="step-card">
                            <div className="step-num">3</div>
                            <h3>24/7 Support</h3>
                            <p>Our dedicated support team is available around the clock to assist you with any queries or concerns.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Shaping Future Section */}
            <section className="shaping-future">
                <div className="container">
                    <div className="shaping-content">
                        <div className="shaping-text">
                            <h2>Together, we're shaping a future where health and happiness go hand in hand.</h2>
                            <p>We believe that transportation should be more than just a utility. It should be a source of joy and freedom, contributing to your overall well-being.</p>
                        </div>
                        <div className="shaping-image">
                            <div className="road-trip-card">
                                <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2070&auto=format&fit=crop" alt="Road Trip" />
                                <div className="card-overlay">
                                    <h3>RANN UTSAV ROAD TRIP</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* History Section */}
            <section className="company-history">
                <div className="container">
                    <div className="history-content">
                        <div className="history-text">
                            <h2>Company history</h2>
                            <p>Founded with a vision to revolutionize urban mobility, CabZigo started as a small fleet of dedicated drivers committed to providing safe and reliable transport.</p>
                            <p>Over the years, we've expanded our reach to dozens of cities, serving millions of happy customers. Our focus on quality and reliability has made us a trusted name in the industry.</p>
                            <p>We continue to innovate and grow, always putting our customers and drivers first in everything we do, ensuring every ride is a step towards a better future.</p>
                        </div>
                        <div className="history-image">
                            <img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=2070&auto=format&fit=crop" alt="Founder" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonial Section */}
            <section className="main-testimonial">
                <div className="container">
                    <div className="testimonial-box">
                        <p>"Using this platform has completely changed the way I approach my daily habits. The guidance is clear and easy to follow, which made staying consistent so much easier. I feel more in control of my routine and my progress."</p>
                        <div className="author">Alex Marcera</div>
                        <div className="role">Co-founder of Company</div>
                    </div>
                </div>
            </section>

            {/* Mission Cards */}
            <section className="mission-cards">
                <div className="container">
                    <h2 className="section-title">Living Our mission</h2>
                    <p className="section-sub">Our community are contributing towards our mission everyday</p>
                    <div className="cards-grid">
                        <div className="mission-card">
                            <div className="quote-icon">“</div>
                            <p>The system is incredibly easy to navigate. The support was always available and helpful. I love this approach!</p>
                            <div className="card-author">- Michael Joe</div>
                        </div>
                        <div className="mission-card">
                            <div className="quote-icon">“</div>
                            <p>It helped me feel more confident and accountable. Falling in love with the service. Highly recommended!</p>
                            <div className="card-author">- Amanda Smith</div>
                        </div>
                        <div className="mission-card">
                            <div className="quote-icon">“</div>
                            <p>CabZigo has been a game-changer for me. Daily commutes are now something I actually look forward to.</p>
                            <div className="card-author">- Jeremy Wood</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Goal Section */}
            <section className="goals-section">
                <div className="container">
                    <div className="goals-content">
                        <h2>Daily guidance crafted specifically for your goals.</h2>
                        <p>Experience a personalized service tailored to your needs. Join us today and start your journey towards a better travel experience.</p>
                        <button className="btn-light">Get Started</button>
                    </div>
                </div>
            </section>

            {/* Bottom Links */}
            <section className="bottom-links">
                <div className="container">
                    <div className="links-grid">
                        <div className="link-col">
                            <h3>Want to make a real impact on people's well-being?</h3>
                            <a href="/careers">Become Career</a>
                        </div>
                        <div className="link-col">
                            <h3>Eager to support others on their wellness journey?</h3>
                            <a href="/support">Write to our support</a>
                        </div>
                        <div className="link-col">
                            <h3>Ready to inspire positive lifestyle changes?</h3>
                            <a href="/news">Check latest news</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
